module.exports = function() {
  return new Worker(__webpack_public_path__ + "3632e6de3c60e85c09ca.worker.js");
};